export interface RecursoRow {
    id: number
    tipo_id: number
    tipo_nombre: string
    nombre: string
    descripcion?: string | null
    orden?: number | null
    url: string
    estado_id: number
    fecha_creacion: string
    fecha_modificacion: string | null
    empresa_id?: number
    empresa_nombre?: string
}

export interface RecursoMetadata {
    nombre_archivo: string
    tipo_mime: string
    extension: string
    peso_bytes: number
    ancho?: number
    alto?: number
    duracion_segundos?: number
}

export interface RecursoCreateRequest {
    empresa_ids: number[]
    tipo_id: number
    estado_id?: number
    archivos: ArchivoRecurso[]
}

export interface ArchivoRecurso {
    archivo: File
    nombre: string
    descripcion?: string
}

export interface ActualizarRecursoRequest {
    id: number
    tipo_id: number
    nombre: string
    descripcion?: string
    orden?: number
    url: string
    estado_id: number
    archivo?: File
}

export interface RecursoDetalle {
    id: number
    tipo_id: number
    tipo_nombre: string
    nombre: string
    descripcion?: string | null
    orden?: number | null
    url: string | null
    estado_id: number
    empresa_id?: number
    empresa_nombre?: string
    regional_id?: number
    fecha_creacion: string
    fecha_modificacion: string | null
}

export const ESTADOS_RECURSO = {
    ACTIVO: 1,
    INACTIVO: 2,
} as const

export const TIPOS_RECURSO = {
    IMAGEN: 1,
    VIDEO: 2,
} as const
